import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';
import { getSellerName } from '@/redux/modules/seller';
import { getSellerUrl } from '@/utils/urls';
import { getShippingTypeMessageId } from './helpers/getShippingTypeMessageId';
import { ShippingMethods } from '@/enums/shippingMethod';
import { useAppSelector } from '@/redux/hooks';
import InPageMessage from '@liveauctioneers/caterwaul-components/lib/InPageMessage/InPageMessage';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styled from 'styled-components';

type PaymentProcessedNotificationProps = {
    houseId: number;
    shippingMethod: ShippingMethods;
};

const PaymentProcessedNotification = ({ houseId, shippingMethod }: PaymentProcessedNotificationProps) => {
    const email = useAppSelector(getBidderEmail);
    const houseName = useAppSelector((state) => getSellerName(state, houseId));
    const houseUrl = getSellerUrl(houseId, houseName);
    const messageTranslationId = getShippingTypeMessageId(shippingMethod);

    return (
        <StyledPaymentProcessedNotification>
            <InPageMessage type="success">
                <FormattedMessage
                    id={messageTranslationId}
                    values={{
                        email: <b key="bold-email">{email}</b>,
                        house: (
                            <Link
                                key="checkout-payment-processed-house-link"
                                route
                                to={houseUrl}
                            >
                                {houseName}
                            </Link>
                        ),
                    }}
                />
            </InPageMessage>
        </StyledPaymentProcessedNotification>
    );
};

export default PaymentProcessedNotification;

const StyledPaymentProcessedNotification = styled.div`
    margin-top: 32px;
`;
